import { useState } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import Reveal from "@/components/feature/Reveal";
import { faqs } from "@/mocks/site";

export default function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <span className="text-xs font-medium tracking-[0.22em] text-primary-600">常见问题</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              先把方法讲清楚，再开始吃瓜
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们整理了读者最常问的几个问题，关于内容来源、时间线的整理方式，以及「未删减原稿」到底指什么。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {preview.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={item.question} delay={index * 70}>
                    <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                      <h3>
                        <button
                          type="button"
                          onClick={() => setOpenIndex(isOpen ? null : index)}
                          className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                          aria-expanded={isOpen}
                        >
                          <span className="font-heading text-base font-semibold text-foreground-950">
                            {item.question}
                          </span>
                          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                            <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                          </span>
                        </button>
                      </h3>
                      {isOpen ? (
                        <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                          {item.answer}
                        </p>
                      ) : null}
                    </article>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}